import React from "react";

const Settings = () => {
    return <div className='dashboard-inner'>Setting</div>
}
export default Settings;